/* eslint-disable */
export const NODATA = 'Datos no Proporcionados'
